// extracted by mini-css-extract-plugin
export default {"cls1":"KEtpvFOHjtTPtICfOJas","cls2":"h1nrjExmANReA8ZXcCP9 KEtpvFOHjtTPtICfOJas"};